<template>
  <div class="Rate" v-if="length > 0">
    <input type="hidden" :name="name" v-model="rate" :required="required">
    <template v-for="n in length">
      <button type="button" :key="n" :class="{'Rate__star': true, 'hover': n <= over, 'filled': (n <= rate || isFilled(n))}" @mouseover="onOver(n)" @mouseout="onOut(n)" @click="setRate(n)" @keyup="onOver(n)" @keyup.enter="setRate(n)" :disabled="disabled">
        <i class="material-icons icon">{{ (n <= rate) || isFilled(n) ? 'star' : 'star_border'}}</i>
      </button>
    </template>
    <div class="Rate__view" :class="{disabled: disabled}">
      <span class="count" v-if="showcount">{{over}}</span>
      <span class="desc" v-if="ratedesc.length > 0 && over !== 0">{{ratedesc[over -1 ].name}}</span>
    </div>
  </div>
</template>

<script>
  /**
   *  example : <rate :length="5" :value="2" @before-rate="onBeforeRate" @after-rate="onAftereRate" />
   *  events: @before-rate, @after-rate
   */
  export default {
    name: 'StarRatingControl',
    props: {

      /**
       * Default value.
       */
      value: {
        type: [Number, String]
      },

      name: {
        type: String,
        default: 'rate'
      },

      /**
       * Star size.
       */
      length: {
        type: Number
      },

      /**
       * Shows rate number when mouseover the star.
       */
      showcount: {
        type: Boolean
      },

      required: {
        type: Boolean
      },

      /**
       * Rate star description array.
       */
      ratedesc: {
        type: Array,
        default: () => []
        },

      /**
       * Disable rate.
       */
      disabled: {
        type: Boolean,
        default: false
      },

      /**
       * Read-only rate.
       */
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        over: 0,
        rate: 0
      }
    },
    methods: {
      convertValue(value) {
        if (value >= this.length) {
          value = this.length
        } else if (value < 0) {
          value = 0
        }
        return value
      },
      onOver (index) { if (!this.readonly) this.over = index },
      onOut () { if (!this.readonly) this.over = this.rate },
      setRate (index) {
        if (this.readonly) return false
        this.$emit('before-rate', this.rate)
        this.rate = index
        this.$emit('input', this.rate)
        this.$emit('after-rate', this.rate)
      },
      isFilled (index) { return index <= this.over },
      isEmpty (index) {
        return index > this.over || !this.value && !this.over
      }
    },
    watch: {
      value() {
        this.rate = this.convertValue(this.value)
        this.over = this.convertValue(this.value)
      }
    },
    created () {
      if (this.value >= this.length) {
        this.value = this.length
      } else if (this.value < 0) {
        this.value = 0
      }
      this.rate = this.convertValue(this.value)
      this.over = this.convertValue(this.value)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .icon {
    display: inline-block;
    font-size: 50px !important;
    vertical-align: middle;
  }
  .Rate{cursor: default;}
  .Rate__star{
    color: #dedbdb;
    display: inline-block;
    padding: 7px 2px;
    text-decoration: none;
    cursor: pointer;
    background: transparent none;
    border: 0;
  }
  .Rate__star .icon{
    vertical-align: middle;
  }
  .Rate__star.hover{
    color: #786006;
  }
  .Rate__star.filled{
    color: #efc20f;
  }
  .Rate__star:hover,
  .Rate__star:focus{text-decoration: none;}
  .Rate__view .count,
  .Rate__view .desc{
    display: inline-block;
    vertical-align: middle;
    padding: 7px
  }
  .Rate.has-error .Rate__star{color: #f37a77;}
  .Rate.has-error .Rate__star.hover{color: #efc20f;}
  .Rate.has-error .Rate__star.filled{color: #efc20f;}
  .Rate__star[disabled]{
    opacity: 0.8;
  }
  .Rate__star.hover[disabled],
  .Rate__star.filled[disabled]{
    color: #efc20f;
    opacity: 0.6;
  }
  .Rate__view.disabled .count,
  .Rate__view.disabled .desc{
    color: #CCC;
  }
</style>
